<template>
    <div class=" margin-center flex-wrap vr-fff" :style="style" >
<!--        <div class="grid-body" v-for="(item,i) in 9" :key="i">-->
<!--            <div class="grid-content">-->
<!--                <img class="g-c-img" src="http://browser9.qhimg.com/bdm/480_296_0/t01cd97ec806b712059.jpg"/>-->
<!--            </div>-->
<!--            <div class="grid-info">-->
<!--                <li class="title-before">望谟县大观镇伏开村全景图</li>-->
<!--                <li class="title-before">项目编号：GYNJS234234</li>-->
<!--                <li class="title-before">项目地址：贵州省黔西南州望谟县大关乡上伏开村一组</li>-->
<!--                <li class="title-before"><span class="see cuIcon-attentionfill ">123</span><img src="../assets/svg/praise.svg" alt=""> <span class="praise ">131</span></li>-->
<!--            </div>-->
<!--        </div>-->
                <div class="grid-body" style="height: 307px" v-for="(item,i) in vrInfo1" :key="i" @click="$router.push({path: '/vrinfo' ,query: { data: item.id}})">
<!--                <div class="grid-body" v-for="(item,i) in vrInfo" :key="i" @click="$router.push({ name: 'vrinfo', params: { id: item.id }})">-->
                    <div class="grid-content">

                        <img class="g-c-img" v-if="item.coverList[0]" :src="item.coverList[0]"/>
                        <div v-else style="display: flex;align-items: center;justify-content: center;background-color:#e4e5ea " class="g-c-img"><img height="20" src="../assets/svg/nullImg.svg" alt=""></div>
                        <!--                        <img class="g-c-img" src="https://axure.tdin360.com/kdxt/images/index/%E5%85%A8%E6%99%AF%E7%BC%A9%E7%95%A5%E5%9B%BE_u77.jpg"/>-->
<!--                        <img class="g-c-img" src="http://browser9.qhimg.com/bdm/480_296_0/t01cd97ec806b712059.jpg"/>-->
                    </div>
                    <div class="grid-info">
                        <li class="title-before">{{item.name}}</li>
                        <li class="title-before">项目编号：{{item.numberNo}}</li>
                        <li class="title-before">项目地址：{{item.address}}</li>
                        <li class="title-before gn" style="padding-top: 24px;"><span class="see cuIcon-attentionfill ">{{item.views}}</span>
<!--                            <img src="../assets/svg/praise.svg" alt=""> <span class="praise ">{{item.praise}}</span>-->
                        </li>
                    </div>
                </div>
    </div>
</template>

<script>
    export default {
        name: "vr-item1",
        props: {
            vrInfo1: {
                type: Array,
                default: []
            },
        },
        data(){
          return{
              style:''
          }
        },
        created(){
            if (!!window.ActiveXObject || "ActiveXObject" in window){
                console.log('ieeeeeeeeeee',true)
                this.style = 'display:flex'
            }
        }
    }
</script>

<style scoped>
    /*    */
    li{
        list-style: none;
    }
    .vr-fff{
        max-width: 1205px;
        justify-content: center;
        display: grid;
        grid-template-columns: repeat(5,224px);
        flex-wrap: wrap;
        grid-auto-flow: row;
    }
    .margin-center{
        margin:0 auto;
    }
    .grid-body {
        /*background-color: antiquewhite;*/
        overflow: hidden;
        max-width: 224px;
        /*padding-right: 4.5px;*/
        padding-left: 4.5px;
        height: 315px;
        margin-bottom: 10px;
        display: flex;
        flex-wrap: wrap;
    }
    /*.grid-body:last-child{*/
    /*    margin-right: auto;*/
    /*}*/
    .grid-body:first-child{
        grid-column: 1 / 3;
        max-width: 464px;
    }

    .grid-content {
        /*background-color: rgb(44, 143, 121);*/
        border-radius: 4px;
        overflow: hidden;
        /*width: 224px;*/
        /*width: inherit;*/
        width: 100%;
        height: 224px;
    }

    .grid-info {
        background-color: rgba(255, 255, 255, 1);
        transition: all 0.6s;
        overflow: hidden;
        position: relative;
        bottom: 0;
        border-radius: 0 0 5px 5px;
        width: 100%;
        /*width: inherit;*/
    }

    .grid-body:nth-child(1) .grid-info .gn{
        padding-top: 0 !important;
    }
    .grid-body:nth-child(1) .grid-content >img {
        position: relative;
        left: 0;
    }

    /*.grid-body:nth-child(1) .grid-content >img{*/
    /*    position: relative;*/
    /*    left: 0;*/
    /*}*/

    .g-c-img {
        transition: all 0.6s;
        /*background-color: red;*/
        filter: blur(0px);
        /*width: 224px;*/
        /*width: inherit;*/
        /*height: 224px;*/
        height: 100%;
        width: 100%;
        background-size: 100% 100%;
        transform: scale(1.04); /*解决不满高度*/
        position: relative;
        /*left: -118px;*/
    }

    .title-before {
        text-align: left;
        font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
        color: rgba(60, 60, 67, 0.6);
        padding-top: 5px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .title-before:nth-child(1) {
        font-weight: 650;
        font-size: 14px;
        color: #000;
    }
    .see{
        padding-right:15px;
    }
    .praise::before{
    padding: 2px;
    }
    .see::before{
        padding: 2px;
    }
    @media only screen and (max-width: 767px) {
        .gn{
            padding-top: 0 !important;
        }
        .grid-body{
            height: 255px !important;
        }
        .grid-content{
            height: 168px;
        }
        .vr-fff{
            /*grid-template-columns: repeat(2,175px) !important;*/
            grid-template-columns:auto auto !important;;
        }
        .grid-body{
            max-width: 664px;
            padding-left: 4px;
            padding-right: 4px
        }
        .grid-body:first-child{
            grid-column: 1 / 1;
            /*max-width: 464px;*/
        }
    }

    @media only screen and (max-width: 992px) {
        .vr-fff{
            grid-template-columns: repeat(3,224px);
        }
    }
    @media only screen and (min-width: 992px) {
        .grid-body:hover .grid-content > img {
            transform: scale(1.2);
        }

        .grid-body:hover .grid-info {
            bottom: 30px;
        }
        .vr-fff{
            grid-template-columns: repeat(4,224px);
        }
    }

    @media only screen and (min-width: 1200px) {
        .vr-fff{
            grid-template-columns: repeat(5,240px);
        }
    }

    @media only screen and (min-width: 1920px) {

    }
</style>